const workflowTaskFilters = {
  workflowInstanceId: null,
  assignedToUserId: null,
  statusId: null,
  dueDateFrom: null,
  dueDateTo: null,
  clientId: null,
  showCompleted: false
}

export default () => Object.assign({}, workflowTaskFilters)
